const nav = require('../utils/nav').Utils;
const auth = require('../utils/auth').Auth;

exports.AvailabilityPageService = {
    getMine: function (callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback(null, JSON.parse(xmlhttp.responseText));
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl('farm/availabilityPage/me'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    getByPublishedURL: function(publishedURL, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    try {
                        callback(null, JSON.parse(xmlhttp.responseText));
                    } catch (ex) {
                        // ignore
                    }
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl(`farm/availabilityPage/${publishedURL}`), true);
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    put: function (availabilityPage, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback(null, JSON.parse(xmlhttp.responseText));
                } else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('PUT', auth.getFullUrl('farm/availabilityPage'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(availabilityPage));
    },

    putHeader: function (availabilityPage, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback(null, JSON.parse(xmlhttp.responseText));
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('PUT', auth.getFullUrl('farm/availabilityHeader'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(availabilityPage));
    },

    hold: function (apID, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('POST', auth.getFullUrl('hold'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify({
            "availabilityPageID" : apID
        }));
    }
};